const sanitizeObject = obj => {
  Object.keys(obj).forEach(key =>
    obj[key] === undefined ? delete obj[key] : ''
  )
  return obj
}

const convertToReadableDate = date => {
  date = new Date(date)
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}

const cookiesToObject = str => {
  return str.split('; ').reduce((prev, current) => {
    const [name, value] = current.split('=')
    prev[name] = value
    return prev
  }, {})
}

function downloadText(filename, text) {
  var element = document.createElement('a')
  element.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
  )
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}

const sortMethods = {
  alphabetical: (a, b) => b.localeCompare(a),
  number: (a, b) => b - a,
  date: (a, b) => new Date(b).getTime() - new Date(a).getTime(),
  alert: (a, b) =>
    ['Critical', 'Warning', 'None'].indexOf(a) -
    ['Critical', 'Warning', 'None'].indexOf(b),
  group: (a, b) => (a == null ? 1 : b == null ? -1 : b.localeCompare(a))
}

function isUrlExternal(url) {
  var host = window.location.host

  var linkHost = (function(url) {
    if (/^https?:\/\//.test(url)) {
      // Absolute URL.
      // The easy way to parse an URL, is to create <a> element.
      // @see: https://gist.github.com/jlong/2428561
      var parser = document.createElement('a')
      parser.href = url

      return parser.host
    } else {
      // Relative URL.
      return window.location.host
    }
  })(url)

  return host !== linkHost
}

const sortReportsByAlerts = reports => {
  const reportAlertCounts = reports.map((report, i) => ({
    critical: report.alerts.filter(alert => alert.alertLevel === 'Critical')
      .length,
    warning: report.alerts.filter(alert => alert.alertLevel === 'Warning')
      .length,
    index: i
  }))

  const indexes = reportAlertCounts
    .sort((a, b) =>
      b.critical - a.critical ? b.critical - a.critical : b.warning - a.warning
    )
    .map(reportAlertCount => reportAlertCount.index)

  return indexes.map(i => reports[i])
}

const sortAppCodesByAlerts = appCodes => {
  const reportAlertCounts = appCodes.map((appCode, i) => ({
    critical: appCode.reports.map(
      report =>
        report.alerts.filter(alert => alert.alertLevel === 'Critical').length
    ),
    warning: appCode.reports.map(
      report =>
        report.alerts.filter(alert => alert.alertLevel === 'Warning').length
    ),
    index: i
  }))

  const indexes = reportAlertCounts
    .sort((a, b) =>
      b.critical - a.critical ? b.critical - a.critical : b.warning - a.warning
    )
    .map(reportAlertCount => reportAlertCount.index)

  return indexes.map(i => appCodes[i])
}

export {
  sanitizeObject,
  convertToReadableDate,
  cookiesToObject,
  sortMethods,
  sortReportsByAlerts,
  sortAppCodesByAlerts,
  downloadText,
  isUrlExternal
}
